import { Routes } from '@angular/router';
import { authGuard, loggedOutGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loggedOutGuard],
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'login-failed',
    loadComponent: () => import('./pages/login/login-failed.component').then(m => m.LoginFailedComponent),
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', canActivate: [authGuard], loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent) },
  { path: 'tenants', canActivate: [authGuard], loadComponent: () => import('./pages/tenants/tenants.component').then(m => m.TenantsComponent) },
  { path: 'tenants/:id', canActivate: [authGuard], loadComponent: () => import('./pages/tenant-detail/tenant-detail.component').then(m => m.TenantDetailComponent) },
  { path: 'catalog', canActivate: [authGuard], loadComponent: () => import('./pages/catalog/catalog.component').then(m => m.CatalogComponent) },
  { path: 'admin', canActivate: [authGuard], loadComponent: () => import('./pages/admin-console/admin-console.component').then(m => m.AdminConsoleComponent) },
  { path: 'databases', canActivate: [authGuard], loadComponent: () => import('./pages/databases/databases.component').then(m => m.DatabasesComponent) },
  { path: 'license', canActivate: [authGuard], loadComponent: () => import('./pages/license/license.component').then(m => m.LicenseComponent) },
  { path: 'entitlements', canActivate: [authGuard], loadComponent: () => import('./pages/entitlements/entitlements.component').then(m => m.EntitlementsComponent) },
  { path: 'seats', canActivate: [authGuard], loadComponent: () => import('./pages/seats/seats.component').then(m => m.SeatsComponent) },
  { path: 'overrides', canActivate: [authGuard], loadComponent: () => import('./pages/overrides/overrides.component').then(m => m.OverridesComponent) },
  { path: 'usage', canActivate: [authGuard], loadComponent: () => import('./pages/usage/usage.component').then(m => m.UsageComponent) },
  { path: 'audit', canActivate: [authGuard], loadComponent: () => import('./pages/audit/audit.component').then(m => m.AuditComponent) },
  { path: '**', redirectTo: 'dashboard' },
];
